import style from './style.module.scss';

export const ProviderLoginButton = ({ text, icon, background = '#e14f45', backgroundHover = '#b43f37' }) => (
    <div className={style.block} style={{ '--providerBg': background, '--providerBgHover': backgroundHover }}>
        <a
            className={style.button}
            href={`/wp-login.php?loginSocial=${text.toLowerCase()}`}
            rel="nofollow"
            aria-label={text}
            data-plugin="nsl"
            data-action="connect"
            data-redirect="current"
            data-provider={text.toLowerCase()}
            data-popupwidth="600"
            data-popupheight="600"
        >
            {icon}
            {text}
        </a>
    </div>
);
